import script from "./VcfsCreatePaymentsPopUp.vue?vue&type=script&setup=true&lang=ts"
export * from "./VcfsCreatePaymentsPopUp.vue?vue&type=script&setup=true&lang=ts"

import "./VcfsCreatePaymentsPopUp.vue?vue&type=style&index=0&id=d75a7d4a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d75a7d4a"]])

export default __exports__